<template>
  <CompanyWrapper>
    <main class="main">
      <EventList
        :lang="lang"
        :langPath="langPath"
        :userName="userName"
      ></EventList>
    </main>
  </CompanyWrapper>
</template>

<script>
import cognito from "../../../../plugins/cognito";
import CompanyWrapper from "../../../../components/pc/company/CompanyWrapper";
import EventList from "../../../../components/pc/top/EventList";
export default {
  data() {
    return {
      userName: "",
    };
  },
  created() {
    this.userName = cognito.getUserName();
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    CompanyWrapper,
    EventList,
  },
  name: "Summary",
};
</script>

<style scoped>
.main {
  margin: 35px auto 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/company/summary/Summary.vue